import type { Middleware } from '@reduxjs/toolkit';

export const loggingMiddleware: (env: EnvType) => Middleware = (env: EnvType) => () => (next) => (action) => {
  if (env !== 'production') {
    // eslint-disable-next-line no-console
    // console.info(`Dispatched action ${action.type} with payload`, action.payload);
  }
  return next(action);
};
